import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Formatação de moeda brasileira
export const formatCurrency = (value) => {
  if (!value && value !== 0) return 'R$ 0,00';
  
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

// Formatação de data brasileira
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'dd/MM/yyyy', { locale: ptBR });
  } catch (error) {
    return dateString;
  }
};

// Formatação de data e hora brasileira
export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR });
  } catch (error) {
    return dateString;
  }
};

// Formatação de data relativa (ex: "há 2 dias")
export const formatRelativeDate = (dateString) => {
  if (!dateString) return '-';
  
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Hoje';
    if (diffDays === 1) return 'Ontem';
    if (diffDays < 7) return `Há ${diffDays} dias`;
    if (diffDays < 30) return `Há ${Math.floor(diffDays / 7)} semanas`;
    if (diffDays < 365) return `Há ${Math.floor(diffDays / 30)} meses`;
    
    return `Há ${Math.floor(diffDays / 365)} anos`;
  } catch (error) {
    return dateString;
  }
};

// Formatação de CPF/CNPJ
export const formatCPFCNPJ = (value) => {
  if (!value) return '-';
  
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length === 11) {
    // CPF
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (cleaned.length === 14) {
    // CNPJ
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  
  return value;
};

// Formatação de telefone
export const formatPhone = (value) => {
  if (!value) return '-';
  
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  
  return value;
};

// Formatação de status de cobrança
export const formatCobrancaStatus = (status) => {
  const statusMap = {
    'nao_cobrado': 'Não Cobrado',
    'cobrado': 'Cobrado',
    'promessa_pagamento': 'Promessa de Pagamento',
    'parcialmente_pago': 'Parcialmente Pago',
    'pago': 'Pago',
  };
  
  return statusMap[status] || status;
};

// Formatação de status de vencimento
export const formatVencimentoStatus = (status) => {
  const statusMap = {
    'Vencido': 'Vencido',
    'Vence Hoje': 'Vence Hoje',
    'Vence em Breve': 'Vence em Breve',
    'No Prazo': 'No Prazo',
  };
  
  return statusMap[status] || status;
};

// Formatação de número com separadores de milhares
export const formatNumber = (value) => {
  if (!value && value !== 0) return '0';
  
  return new Intl.NumberFormat('pt-BR').format(value);
};

// Formatação de porcentagem
export const formatPercentage = (value) => {
  if (!value && value !== 0) return '0%';
  
  return `${value.toFixed(2)}%`;
};

// Formatação de moeda abreviada (ex: 1.000.000 → R$ 1,00M)
export const formatCurrencyAbbreviated = (value) => {
  if (!value && value !== 0) return 'R$ 0,00';
  
  const num = parseFloat(value);
  
  if (num >= 1000000000) {
    return `R$ ${(num / 1000000000).toFixed(2).replace('.', ',')}B`;
  } else if (num >= 1000000) {
    return `R$ ${(num / 1000000).toFixed(2).replace('.', ',')}M`;
  } else if (num >= 1000) {
    return `R$ ${(num / 1000).toFixed(2).replace('.', ',')}K`;
  } else {
    return formatCurrency(num);
  }
}; 